const stateHelpers = {
    updateState(state, selector, newVal, autoAssign = true) {
        let newState = _recUpdateState(state, selector, newVal);
        if (autoAssign) {
            return Object.assign(state, newState);
        }
        return newState;
    },
    updateDraftState(draftState, selector, newVal) {
        _setNestedValue(draftState, selector, newVal);
    },
    fetchState(state, selector) {
        if (selector.length > 1) {
            const field = selector.shift();
            let subObject = {};
            try {
                subObject = { ...this.fetchState(state[field], selector) }
            } catch (ex) {
                return undefined;
            }
            return subObject;
        } else {
            return state[selector.shift()];
        }
    }
}

function _setNestedValue(state, selector, newVal) {
    if (selector.length > 1) {
        const field = selector.shift();
        _setNestedValue(state[field], selector, newVal);
    } else {
        const field = selector.shift();
        state[field] = newVal;
    }
}

function _recUpdateState(state, selector, newVal) {
    if (selector.length > 1) {
        const field = selector.shift();
        let subObject = {};
        try {
            subObject = { ..._recUpdateState(state[field], selector, newVal) };
        } catch (ex) {
            subObject = { ..._recUpdateState(state, selector, newVal) };
        }

        return { ...state, [field]: subObject };
    } else {
        let updatedState = {};
        updatedState[selector.shift()] = newVal;
        return { ...state, ...updatedState };
    }
}

export default stateHelpers;